module.exports = __webpack_public_path__ + "img/btn_noti_check.9435d056.svg";